export default "__VITE_ASSET__DOEisWDV__"